export default __webpack_public_path__ + "static/callum-faris-face-surgery-article-59184b69f755088b9a850420c6e46ed7.jpg";